import { Button } from '@/shared/components/ui/button'
import { AlertCircle, Plus, Wand2, ListVideo } from 'lucide-react'
import { FeatureEmptyState } from '@/shared/components/custom/FeatureEmptyState'

interface ShotListEmptyStateProps {
    sceneName: string
    error: string | null
    setIsAIDialogOpen: (open: boolean) => void
    handleCreateManually: () => void
}

const ShotListEmptyState = ({
    sceneName,
    error,
    setIsAIDialogOpen,
    handleCreateManually,
}: ShotListEmptyStateProps) => {
    return (
        <FeatureEmptyState
            className="h-[60vh] py-20 bg-muted/5 border border-dashed rounded-lg"
            icon={<ListVideo className="h-10 w-10 text-primary" />}
            title="No Shot List Found"
            description={
                <span>Create a shot list for <span className="font-semibold text-foreground">"{sceneName}"</span> to plan your production.</span>
            }
        >
            {error && (
                <div className="flex items-center gap-2 text-destructive bg-destructive/10 p-3 rounded-md mb-2">
                    <AlertCircle className="h-4 w-4" />
                    <span className="text-sm">{error}</span>
                </div>
            )}

            <div className="flex gap-4">
                <Button onClick={() => setIsAIDialogOpen(true)} size="lg" className="gap-2">
                    <Wand2 className="h-4 w-4" />
                    Generate with AI
                </Button>
                <Button onClick={handleCreateManually} variant="outline" size="lg" className="gap-2">
                    <Plus className="h-4 w-4" />
                    Create Manually
                </Button>
            </div>
        </FeatureEmptyState>
    )
}

export default ShotListEmptyState
